import {Component, Inject, OnInit} from '@angular/core';
import {DialogComponentInterface} from '../dialog-component.interface';
import {MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {TranslationContainerComponent} from '../../abstract/translation-container.component';
import {logoUrl, salesChannel} from '../../../../core/utils/utils';
import {SalesChannel} from '../../../../core/consts/sales-channel.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-offer-update-dialog',
  templateUrl: './offer-update-dialog.component.html'
})
export class OfferUpdateDialogComponent extends TranslationContainerComponent implements OnInit, DialogComponentInterface {

  logoUrl: string = logoUrl();
  additionalLogoUrl: string;
  logoVisible: boolean = true;
  imageUrl: string = './assets/images/offer-update.gif';

  private config: OfferUpdateDialogSalesChannelConfig;
  private readonly SALES_CHANNEL_CONFIGS: OfferUpdateDialogSalesChannelConfig[] = [
    {
      salesChannel: SalesChannel.YANOSIK,
      logoUrl: './assets/images/logo/yanosik-black.svg',
      imageUrl: './assets/images/offer-update-yanosik.gif'
    },
    {
      salesChannel: SalesChannel.BANKIER,
      imageUrl: './assets/images/offer-update-bankier.gif'
    },
    {
      salesChannel: SalesChannel.MPAY,
      imageUrl: './assets/images/offer-update-mpay.gif'
    },
    {
      salesChannel: SalesChannel.NESTBANK,
      imageUrl: './assets/images/offer-update-nestbank.gif',
      additionalLogoUrl: './assets/images/logo/nestbank-logo.svg'
    },
    {
      salesChannel: SalesChannel.SKYCASH,
      imageUrl: './assets/images/offer-update-skycash.gif'
    },
    {
      salesChannel: SalesChannel.CARONE,
      logoDisabled: true,
      imageUrl: './assets/images/offer-update-carone.gif'
    }
  ];

  static getConfigBuilder(): OfferUpdateDialogConfig {
    return new OfferUpdateDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super('OFFER_UPDATE_DIALOG');
  }

  ngOnInit() {
    this.initConfig();
    this.initLogos();
    this.initImage();
  }

  private initConfig(): void {
    this.config = this.SALES_CHANNEL_CONFIGS.find(item => item.salesChannel === salesChannel());
  }

  private initLogos(): void {
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.logoUrl)) {
      this.logoUrl = this.config.logoUrl;
    }
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.logoDisabled)) {
      this.logoVisible = !this.config.logoDisabled;
    }
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.additionalLogoUrl)) {
      this.additionalLogoUrl = this.config.additionalLogoUrl;
    }
  }

  private initImage(): void {
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.imageUrl)) {
      this.imageUrl = this.config.imageUrl;
    }
  }

}

export interface OfferUpdateDialogSalesChannelConfig {
  salesChannel: SalesChannel;
  logoUrl?: string;
  additionalLogoUrl?: string;
  logoDisabled?: boolean; // default - false
  imageUrl?: string;
}

export class OfferUpdateDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: ['app-dialog', 'offer-update-dialog-panel'],
    disableClose: true
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
